import { Button, Stack, Tooltip, Typography, useTheme } from "@mui/material";

export type RevertHelperLineProps = {
  label: string;
  displayValue: string;
  tooltip: string;
  onClick: () => void;
};

export function RevertHelperLine({
  label,
  displayValue,
  tooltip,
  onClick,
}: RevertHelperLineProps): JSX.Element {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography variant="body2" component="span" color="text.secondary">
        {label}: <span style={{ fontStyle: "italic" }}>{displayValue}</span>
      </Typography>
      <Tooltip title={tooltip}>
        <Button
          onClick={onClick}
          type="button"
          variant="text"
          sx={{ color: theme.palette.text.secondary }}
          size="small"
        >
          Revert
        </Button>
      </Tooltip>
    </Stack>
  );
}
